import React,{ useState} from 'react';
import data from './data';
import { FaChevronLeft, FaChevronRight, FaQuoteRight} from 'react-icons/fa';

export default function Review() {
    const [index, setIndex] = useState(0);
  const {name, job, image, text} = data[index];

    const checkNumber = (number) =>{
        if(number > data.length -1 ){
            return 0;
        }
        if(number < 0){
            return data.length -1;
        }
        return number;
    }
    const nextPerson = () =>{
        setIndex((index)=>{
            let newIndex = index + 1;
            return checkNumber(newIndex);
        })
    }
    const prevPerson = () =>{
        setIndex((index)=>{
            let newIndex = index - 1;
            return checkNumber(newIndex);
        })
    }

    const randomPerson = () => {
        let randomNumber = Math.floor(Math.random() * data.length);

        if(randomNumber === index){
            randomNumber = index+1;
        }
        setIndex(checkNumber(randomNumber))
        console.log(randomNumber) 

    }

    return (
        <main>
            <div className="card-body text-center">
                <img className="img-size my-3" src={image} alt={name} />
                <span className="quote-icon">
                <FaQuoteRight /> </span>
                <h4 className="card-title mb-3">{name}</h4>
                <h3 className="text-info my-3">{job}</h3>
                <p className="card-text text-justify my-4 text">{text}</p>
                <div className="container my-3">
                    <button className="btn btn-outline-info" onClick={prevPerson}>
                        <FaChevronLeft />
                    </button>
                    <button className="btn btn-outline-info" onClick={nextPerson}>
                        <FaChevronRight />
                    </button>
                </div>
                
                    <button className="btn btn-info" onClick={randomPerson}>Suprise me</button>
                
            </div>
            
        </main>
    )
}
